import { render } from "./ScarAfterBurn.vue?vue&type=template&id=17793e70&scoped=true"
import script from "./ScarAfterBurn.vue?vue&type=script&lang=js"
export * from "./ScarAfterBurn.vue?vue&type=script&lang=js"

import "./ScarAfterBurn.vue?vue&type=style&index=0&id=17793e70&scoped=true&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17793e70"]])

export default __exports__